import { render, staticRenderFns } from "./bundingEmail.vue?vue&type=template&id=8c3244c4&"
import script from "./bundingEmail.vue?vue&type=script&lang=js&"
export * from "./bundingEmail.vue?vue&type=script&lang=js&"
import style0 from "./bundingEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports